import React, { Component } from 'react'
import './css/video.css'

const Video= (props) => {
  return(
    <div className='videos' id="container" >

    </div>
  );
}

export default Video;



// WEBPACK FOOTER //
// ./src/video.js